import {Accordion} from '@mui/material';
import muiStyled from '@mui/material/styles/styled';

const StyledAccordion = muiStyled(Accordion)(({theme}) => ({
  '&.Mui-expanded': {
    margin: 0
  },
  border: `1px solid #DEDEDE`
}));

export default StyledAccordion;
